// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"ad1e61ac","52":"8b87bf23","251":"8cbb58be","310":"c465cbf6","352":"2c97d5ea","372":"8d39fd6a","453":"5a1a1639","563":"ceb3cd9c","610":"f05047c6","820":"3b8dbe7c","822":"98f1e9de","958":"e563532d","987":"af1d2e83"}[chunkId] + ".chunk.js";
};